import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchReconCompanyList } from '../actions/reconciliationTypes'

const useFetchingEssentialsReconCompanies = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchReconCompanyList('essentials'))
  }, [dispatch])
}

export default useFetchingEssentialsReconCompanies
